<template>
  <div class="dem-edi-pro">
    <div class="item-titulo">
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      Produtos

      <!-- SETA O BOBTÃO PARA OCULTAR E MOSTRAR -->
      <span @click="demEdiProUpdateVisualizacao" :key="'olho-pro-' + cpntItensProdutoMostrar" v-if="[ 'dev_cliente', 'dev_fornecedor', 'compra' ].indexOf(cpntDemanda) === -1">
        <svg v-if="cpntItensProdutoMostrar !== 's'" class="ocultar_mostrar fa fa-eye-slash"></svg>
        <svg v-else class="ocultar_mostrar fa fa-eye"></svg>
      </span>
    </div>

    <div class="item-conteudo" v-if="cpntItensProdutoMostrar === 's'">
      <!-- SETA O STATUS DE CARREGANDO DA PAGINA -->
      <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

      <!-- ABRE A TELA SOLICITADA -->
      <template v-else>
        <template v-if="[ 'venda', 'dev_cliente' ].indexOf(cpntDemanda) !== -1">
          <div class="itens" :class="'dem_' + cpntDemanda">
            <!-- SETA O FORMULARIO PARA INSERIR -->
            <Demanda-Editar-Produtos-Formulario :key="'for-' + cpntDemandaId" v-if='cpntDemanda !== "dev_cliente" && cpntFinStatus !== "s" && cpntPDocNFEmitida === false && cpntPCOItemMostrarPainel !== "n"'
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            :cpntPDocTp="cpntPDocTp"
            :cpntVendedorDoContato="cpntVendedorDoContato"
            :cpntDemandaTotal="cpntDemandaTotal"

            @APP_COMANDA_RAPIDA="demEdiProComandaRapida"
            @DEMANDA_UPDATE_TABELA="demEdiProUpdateTabela"
            ref="formulario"
            ></Demanda-Editar-Produtos-Formulario>
            <!-- @DEMANDA_UPDATE_TABELA="demEdiProUpdateTabela" -->

            <Demanda-Editar-Produtos-Formulario-Devolucao v-else-if='cpntDemanda === "dev_cliente" && cpntFinStatus !== "s" && cpntPDocNFEmitida === false && cpntPCOItemMostrarPainel !== "n"'
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            
            @DEMANDA_UPDATE_TABELA="demEdiProUpdateTabela"
            ></Demanda-Editar-Produtos-Formulario-Devolucao>

            <!-- SETA A TABELA COM OS DADOS -->
            <Demanda-Editar-Produtos-Tabela :key="('nf-' + cpntPDocNFEmitida) + ('tab-' + cpntDemandaId) + ('con-' + cpntIdCon) + ('df-' + cpntPDocDocs) + ('nf-' + cpntPDocFiscal.DocNumero) + ('val-' + cpntDemandaTotal.produto.liquido) + ('item-' + cpntDemandaTotal.produto.item)"
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            :cpntPDocNFEmitida="cpntPDocNFEmitida"
            :cpntPDocDocs="cpntPDocDocs"
            :cpntIdConIdPais="cpntIdConIdPais"
            :cpntIdVei="cpntIdVei"
            :cpntIdPet="cpntIdPet"
            :cpntIdCon="cpntIdCon"
            :cpntIdConPessoa="cpntIdConPessoa"
            :cpntIdConTpCon="cpntIdConTpCon"
            :cpntIdConUF="cpntIdConUF"
            :cpntPDocTp="cpntPDocTp"
            :cpntPDV="cpntPDV"
            :cpntDemandaTotal="cpntDemandaTotal"
            :cpntFinStatus="cpntFinStatus"
            :cpntVetorDetalhes="detalhes"
            @TABELA_ATUALIZAR_LINHA_ADICIONAL="demEdiProDetalheLinhaAdicional"
            ref="tabela"
            ></Demanda-Editar-Produtos-Tabela>
          </div>

          <div class="documento">
            <Demanda-Editar-Produtos-Documento :key="('doc-' + cpntDemandaId) + ('des-tp-' + cpntPDocDesconto.global_select) + ('des-por-' + cpntPDocDesconto.global_porcentagem) + ('des-val-' + cpntPDocDesconto.global_valor)"
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            :cpntDemandaTotal="cpntDemandaTotal"
            :cpntDemStatus="cpntDemStatus"
            :cpntPDV="cpntPDV"
            :cpntDemData="cpntDemData"
            :cpntIdConPessoa="cpntIdConPessoa"

            :cpntIdConCnpjCpf="cpntIdConCnpjCpf"
            :cpntPDocNFEmitida="cpntPDocNFEmitida"
            :cpntPDocDocs="cpntPDocDocs"
            :cpntPDocCCe="cpntPDocCCe"
            :cpntPDocFiscal="cpntPDocFiscal"
            :cpntPDocTp="cpntPDocTp"
            :cpntPDocTpOptions="cpntPDocTpOptions"
            :cpntPDocOpe="cpntPDocOpe"
            :cpntPDocNatOpe="cpntPDocNatOpe"
            :cpntDocIcmsAa="cpntDocIcmsAa"
            :cpntPDocFin="cpntPDocFin"
            :cpntPDocRefChave="cpntPDocRefChave"
            :cpntPDocIndPres="cpntPDocIndPres"
            :cpntPDocIntermediador="cpntPDocIntermediador"
            :cpntPDocFreTp="cpntPDocFreTp"
            :cpntPDocFrePlacaUf="cpntPDocFrePlacaUf"
            :cpntPDocFrePlaca="cpntPDocFrePlaca"
            :cpntPDocFreVolumes="cpntPDocFreVolumes"
            :cpntPDocRetPrevA="cpntPDocRetPrevA"
            :cpntPDocDataHoraSaiEnt="cpntPDocDataHoraSaiEnt"
            :cpntPDocTransportadora="cpntPDocTransportadora"
            :cpntPDocAcoes="cpntPDocAcoes"
            :cpntPDocEstadoEmbarque="cpntPDocEstadoEmbarque"
            :cpntPDocCidadeEmbarque="cpntPDocCidadeEmbarque"
            :cpntPDocLocalDespacho="cpntPDocLocalDespacho"

            :cpntPDocManualChaveAcesso="cpntPDocManualChaveAcesso"
            :cpntPDocManualDataEmissao="cpntPDocManualDataEmissao"
            :cpntPDocManualNumero="cpntPDocManualNumero"
            :cpntPDocManualSerie="cpntPDocManualSerie"
            :cpntPDocManualFrete="cpntPDocManualFrete"
            :cpntPDocManualSeguro="cpntPDocManualSeguro"
            :cpntPDocDesconto="cpntPDocDesconto"
            :cpntPDocManualOda="cpntPDocManualOda"
            ></Demanda-Editar-Produtos-Documento>
          </div>
        </template>

        <template v-else-if="[ 'compra', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1">
          <div class="documento">
            <Demanda-Editar-Produtos-Documento :key="('doc-' + cpntDemandaId) + ('des-tp-' + cpntPDocDesconto.global_select) + ('des-por-' + cpntPDocDesconto.global_porcentagem) + ('des-val-' + cpntPDocDesconto.global_valor)"
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            :cpntDemandaTotal="cpntDemandaTotal"
            :cpntDemStatus="cpntDemStatus"
            :cpntPDV="cpntPDV"
            :cpntDemData="cpntDemData"
            :cpntIdConPessoa="cpntIdConPessoa"

            :cpntIdConCnpjCpf="cpntIdConCnpjCpf"
            :cpntPDocNFEmitida="cpntPDocNFEmitida"
            :cpntPDocDocs="cpntPDocDocs"
            :cpntPDocCCe="cpntPDocCCe"
            :cpntPDocFiscal="cpntPDocFiscal"
            :cpntPDocTp="cpntPDocTp"
            :cpntPDocTpOptions="cpntPDocTpOptions"
            :cpntPDocOpe="cpntPDocOpe"
            :cpntPDocNatOpe="cpntPDocNatOpe"
            :cpntDocIcmsAa="cpntDocIcmsAa"
            :cpntPDocFin="cpntPDocFin"
            :cpntPDocRefChave="cpntPDocRefChave"
            :cpntPDocIndPres="cpntPDocIndPres"
            :cpntPDocIntermediador="cpntPDocIntermediador"
            :cpntPDocFreTp="cpntPDocFreTp"
            :cpntPDocFrePlacaUf="cpntPDocFrePlacaUf"
            :cpntPDocFrePlaca="cpntPDocFrePlaca"
            :cpntPDocFreVolumes="cpntPDocFreVolumes"
            :cpntPDocRetPrevA="cpntPDocRetPrevA"
            :cpntPDocDataHoraSaiEnt="cpntPDocDataHoraSaiEnt"
            :cpntPDocTransportadora="cpntPDocTransportadora"
            :cpntPDocAcoes="cpntPDocAcoes"
            :cpntPDocEstadoEmbarque="cpntPDocEstadoEmbarque"
            :cpntPDocCidadeEmbarque="cpntPDocCidadeEmbarque"
            :cpntPDocLocalDespacho="cpntPDocLocalDespacho"

            :cpntPDocManualChaveAcesso="cpntPDocManualChaveAcesso"
            :cpntPDocManualDataEmissao="cpntPDocManualDataEmissao"
            :cpntPDocManualNumero="cpntPDocManualNumero"
            :cpntPDocManualSerie="cpntPDocManualSerie"
            :cpntPDocManualFrete="cpntPDocManualFrete"
            :cpntPDocManualSeguro="cpntPDocManualSeguro"
            :cpntPDocDesconto="cpntPDocDesconto"
            :cpntPDocManualOda="cpntPDocManualOda"
            ></Demanda-Editar-Produtos-Documento>
          </div>

          <div class="itens"  :class="'dem_' + cpntDemanda">
            <!-- SETA O FORMULARIO PARA INSERIR -->
            <Demanda-Editar-Produtos-Formulario :key="'for-' + cpntDemandaId" v-if='cpntDemanda !== "dev_fornecedor" && cpntFinStatus !== "s" && cpntPDocNFEmitida === false && cpntPCOItemMostrarPainel !== "n"'
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            :cpntPDocTp="cpntPDocTp"
            :cpntVendedorDoContato="cpntVendedorDoContato"
            :cpntDemandaTotal="cpntDemandaTotal"

            @APP_COMANDA_RAPIDA="demEdiProComandaRapida"
            @DEMANDA_UPDATE_TABELA="demEdiProUpdateTabela"
            ref="formulario"
            ></Demanda-Editar-Produtos-Formulario>
            <!-- @DEMANDA_UPDATE_TABELA="demEdiProUpdateTabela" -->

            <Demanda-Editar-Produtos-Formulario-Devolucao v-else-if='cpntDemanda === "dev_fornecedor" && cpntFinStatus !== "s" && cpntPDocNFEmitida === false && cpntPCOItemMostrarPainel !== "n"'
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            
            @DEMANDA_UPDATE_TABELA="demEdiProUpdateTabela"
            ></Demanda-Editar-Produtos-Formulario-Devolucao>

            <!-- SETA A TABELA COM OS DADOS -->
            <Demanda-Editar-Produtos-Tabela :key="('nf-' + cpntPDocNFEmitida) + ('tab-' + cpntDemandaId) + ('con-' + cpntIdCon) + ('df-' + cpntPDocDocs) + ('nf-' + cpntPDocFiscal.DocNumero) + ('val-' + cpntDemandaTotal.produto.liquido) + ('item-' + cpntDemandaTotal.produto.item)"
            :cpntDemanda="cpntDemanda"
            :cpntDemandaId="cpntDemandaId"
            :cpntPDocNFEmitida="cpntPDocNFEmitida"
            :cpntPDocDocs="cpntPDocDocs"
            :cpntIdConIdPais="cpntIdConIdPais"
            :cpntIdVei="cpntIdVei"
            :cpntIdPet="cpntIdPet"
            :cpntIdCon="cpntIdCon"
            :cpntIdConPessoa="cpntIdConPessoa"
            :cpntIdConTpCon="cpntIdConTpCon"
            :cpntIdConUF="cpntIdConUF"
            :cpntPDocTp="cpntPDocTp"
            :cpntPDV="cpntPDV"
            :cpntDemandaTotal="cpntDemandaTotal"
            :cpntFinStatus="cpntFinStatus"
            :cpntVetorDetalhes="detalhes"
            @TABELA_ATUALIZAR_LINHA_ADICIONAL="demEdiProDetalheLinhaAdicional"
            ref="tabela"
            ></Demanda-Editar-Produtos-Tabela>
          </div>          
        </template>
      </template>
      
      <App-Demanda-Comanda-Rapida v-if="comandaRap === true"
      :cpntDemanda="cpntDemanda"
      :cpntDemandaId="cpntDemandaId"
      :cpntPDocTp="cpntPDocTp"
      :cpntDemandaTotal="cpntDemandaTotal"
      :cpntFecharFormulario="demEdiProComandaRapida"
      :cpntPDocNFEmitida="cpntPDocNFEmitida"
      :cpntPDocFiscal="cpntPDocFiscal"
      ></App-Demanda-Comanda-Rapida>
    </div>
  </div>
</template>

<style scoped>
.dem-edi-pro {
  margin-top: 10px;
}
  .dem-edi-pro > .item-conteudo {
    width: 100%;
    border-radius: 5px;
    margin: 0px;
    padding: 10px;
    min-height: 200px;
    vertical-align: top;

    border: 1px solid #c6c4c4;
    background: #ecfbed;
    background: -webkit-gradient(linear,left top,left bottom,from(#ecfbed),to(#d7f4d6));
    background: linear-gradient(180deg,#ecfbed 0,#d7f4d6);
  }
    .dem-edi-pro > .item-conteudo > .rf-status {
      line-height: 140px;
    }
    .dem-edi-pro > .item-conteudo > .itens {
      display: inline-block;
      /* width: calc(100% - 370px);
      min-width: 370px; */
      vertical-align: top;
    }

    .dem-edi-pro > .item-conteudo > .itens.dem_venda,
    .dem-edi-pro > .item-conteudo > .itens.dem_dev_cliente {
      padding-right: 15px;
    }
    .dem-edi-pro > .item-conteudo > .itens.dem_compra,
    .dem-edi-pro > .item-conteudo > .itens.dem_dev_fornecedor {
      padding-left: 15px;
    }

    .dem-edi-pro > .item-conteudo > .documento {
      display: inline-block;
      vertical-align: top;
    }

   @media only screen and (min-width: 800px) {
    .dem-edi-pro > .item-conteudo > .itens {
      width: calc(100% - 370px);
    }
  }
  @media only screen and (max-width: 799px) {
  .dem-edi-pro > .item-conteudo > .itens {
    width: calc(100% + 15px);
  }
}
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntDemData: {
        required: true
      },
      cpntIdVei: {
        required: false,
        default: function () { return '' }
      },
      cpntIdPet: {
        required: false,
        default: function () { return '' }
      },
      cpntIdCon: {
        required: true
      },
      cpntIdConPessoa: {
        required: true
      },
      cpntIdConTpCon: {
        required: true
      },
      cpntIdConUF: {
        required: true
      },
      cpntIdConIdPais: {
        required: true
      },
      cpntIdConCnpjCpf: {
        required: true
      },
      cpntFinStatus: {
        required: true
      },
      cpntVendedorDoContato: {
        required: true
      },
      cpntItensProdutoMostrar: {
        required: true
      },
      cpntPDocNFEmitida: {
        required: true
      },
      cpntPDocDocs: {
        required: true
      },
      cpntPDocCCe: {
        required: true
      },
      cpntPDocFiscal: {
        required: true
      },
      cpntPDV: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntPDocTpOptions: {
        required: true
      },
      cpntPDocOpe: {
        required: true
      },
      cpntPDocNatOpe: {
        required: true
      },
      cpntDocIcmsAa: {
        required: true
      },
      cpntPDocFin: {
        required: true
      },
      cpntPDocRefChave: {
        required: true
      },
      cpntPDocIndPres: {
        required: true
      },
      cpntPDocIntermediador: {
        required: true
      },
      cpntPDocFreTp: {
        required: true
      },
      cpntPDocFrePlacaUf: {
        required: true
      },
      cpntPDocFrePlaca: {
        required: true
      },
      cpntPDocFreVolumes: {
        required: true
      },
      cpntPDocRetPrevA: {
        required: true
      },
      cpntPDocDataHoraSaiEnt: {
        required: true
      },
      cpntPDocTransportadora: {
        required: true
      },
      cpntPDocAcoes: {
        required: true
      },
      cpntPDocEstadoEmbarque: {
        required: true
      },
      cpntPDocCidadeEmbarque: {
        required: true
      },
      cpntPDocLocalDespacho: {
        required: true
      },
      cpntPDocManualChaveAcesso: {
        required: true
      },
      cpntPDocManualDataEmissao: {
        required: true
      },
      cpntPDocManualNumero: {
        required: true
      },
      cpntPDocManualSerie: {
        required: true
      },
      cpntPDocManualFrete: {
        required: true
      },
      cpntPDocManualSeguro: {
        required: true
      },
      cpntPDocDesconto: {
        required: true
      },
      cpntPDocManualOda: {
        required: true
      },
      cpntDemStatus: {
        required: true
      },
      cpntPCOItemMostrarPainel: {
        required: true
      }
    },
    components: {
      'App-Demanda-Comanda-Rapida': () => import('@/components/demanda/Editar/Demanda-Comanda-Rapida.vue'),
      'Demanda-Editar-Produtos-Formulario': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Formulario.vue'),
      'Demanda-Editar-Produtos-Formulario-Devolucao': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Formulario-Devolucao.vue'),
      'Demanda-Editar-Produtos-Tabela': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Tabela.vue'),
      'Demanda-Editar-Produtos-Documento': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Documento.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        detalhes: [],
        comandaRap: false
      }
    },
    methods: {
      demEdiProSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // DESTRAVA A TELA
        this.$emit('DEMANDA_TRAVAR_TELA', false)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProUpdateVisualizacao: function () {
        // CHAMA A FUNÇÃO PARA TRAVAR A TELA
        this.$emit('DEMANDA_TRAVAR_TELA', true)

        // INICIA O FORMULARIO PARA ENVIAR PARA API
        var formData = { p_mostrar: this.cpntItensProdutoMostrar === 's' ? '0' : '1' }

        // SETA O TIPO REGISTRO DO CAMPO
        formData.cod_venda = this.cpntDemandaId
        
        // // CONVERTE O VALOR EM LOT
        // formData = { lot: [ formData ] }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/venda', 'PUT', formData, (retorno) => {
          // PEGA O RETORNO RECEBIDO 
          retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

          // VERIFICA O RESULTADO DA OPERAÇÃO
          switch (retorno.code) {
            case '200':
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
    
              // ATUALIZA OS DADOS E DESTRAVA A TELA
              this.$emit('DEMANDA_BUSCAR_VALORES', () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
              break

            default:
              // APRESENTA A MENAGEM RECEBIDA
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true)

              // SETA O STATUS DA TELA
              this.$emit('DEMANDA_TRAVAR_TELA', false)
              break
          }
        }, this.demEdiProSetarStatusGeral)
      },
      demEdiProUpdateTabela: function () {
        this.$refs.tabela.demEdiProBuscarLinhas()
      },
      demEdiProDetalheLinhaAdicional: function (vetor) {
        this.detalhes = vetor
      },
      demEdiProComandaRapida: function () {
        // SETA OS VALORES RECEBIDOS
        this.comandaRap = !this.comandaRap

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    watch: {
      cpntDemandaId: function () {
        this.detalhes = []
      }
    }
  }
</script>
